import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { KEYBOARD_HEIGHT, KEYBOARD_OFFSET_X, KEYBOARD_OFFSET_Y, KEYBOARD_WIDTH } from '@bedrock-rdk/constants';

import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const { screenSize, colorMode } = defaultContext;

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    x: KEYBOARD_OFFSET_X[screenSize],
    y: KEYBOARD_OFFSET_Y[screenSize],
    Background: {
      rect: true,
      h: KEYBOARD_HEIGHT[screenSize],
      w: KEYBOARD_WIDTH[screenSize],
      color: colors.background[colorMode],
    },
  };
};
